import React from 'react';
import { useIsMobile } from 'hooks/useIsMobile';

export const withIsMobile = <P extends {}>(Component: React.ComponentType<P>) => {
  type InstType = React.ComponentType<Omit<P, 'isMobile'>>;
  return React.forwardRef<InstType, Omit<P, 'isMobile'>>(function WithIsMobile(props, ref) {
    const isMobile = useIsMobile();
    const Comp: any = Component;
    return <Comp ref={ref} isMobile={isMobile} {...props} />;
  });
};
